import { Suspense, type FunctionComponent } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { Action } from './PluginHeader';

interface LazyPluginBoardBarProps {
  callback?: () => void;
  url: string;
  accentColor: string;
  height: number;
  title?: string;
  actions?: Action[];
  resizable?: boolean;
}

export const LazyPluginBoardBar: FunctionComponent<LazyPluginBoardBarProps> = ({
  callback,
  url,
  accentColor,
  height,
  title,
  actions,
  resizable,
}) => {
  const NewPluginModal = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "NewPluginBoardBar" */ 'app/src/components/Plugins/NewPluginBoardBar'
      ),
    { namedImport: 'NewPluginBoardBar' },
  );
  return (
    <ErrorBoundary>
      <ChunkLoadErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <NewPluginModal
            callback={callback}
            url={url}
            accentColor={accentColor}
            height={height}
            resizable={resizable}
            title={title}
            actions={actions}
          />
        </Suspense>
      </ChunkLoadErrorBoundary>
    </ErrorBoundary>
  );
};
